import React from "react";
import MagicLink from "./magicLink";
import Dropdown from "../CommonComponents/dropDown";

const DropdownMenuList = ({selectedAdminId, selectedCompanyId, handleUpgradeBtnClick}) => {

    const handleClick = () => {
        handleUpgradeBtnClick(selectedCompanyId);
    }
    const getList = () => (
        <>
            <li onClick={handleClick} data-bs-toggle="modal"
                data-bs-target="#planUpgradeModal">
                <span className="dropdown-item">Change Account Plan</span>
            </li>
            <li>
                <MagicLink selectedAdminId={selectedAdminId} selectedCompanyId={selectedCompanyId}/>
            </li>
        </>
    );

    return <Dropdown dropdownArr={getList()}/>;
}

export default DropdownMenuList;
